import { ICard } from 'pages/fbmanager/model/types/card';

import { CardsActionTypes, TCardsActions } from './actions';

interface ICardState {
  cards: ICard[];
  cardNumber: string;
  cardExpiryDate: string;
  cardCvc: string;
}

const initialState: ICardState = {
  cards: [],
  cardNumber: '',
  cardExpiryDate: '',
  cardCvc: '',
};

export const generateId = (card: string): string => {
  return `${Math.floor(Math.random() * 1000) + Date.now() + card}`;
};

export const cardReducer = (state = initialState, action: TCardsActions): ICardState => {
  switch (action.type) {
    case CardsActionTypes.SET_CARDS:
      const cardsWithId = action.payload.map((el) => {
        return { id: generateId(el), value: el };
      });
      return { ...state, cards: [...state.cards, ...cardsWithId] };
    case CardsActionTypes.UPDATE_CARDS:
      const updatedCards = state.cards.map((el) => {
        if (el.id === action.payload.id) {
          return action.payload;
        }
        return el;
      });
      return { ...state, cards: [...updatedCards] };
    case CardsActionTypes.REMOVE_CARDS:
      const cards = state.cards.filter((el) => el.id !== action.payload);
      return { ...state, cards: [...cards] };
    case CardsActionTypes.SET_CARD_NUMBER:
      return { ...state, cardNumber: action.payload };
    case CardsActionTypes.SET_CARD_EXPIRY_DATE:
      return { ...state, cardExpiryDate: action.payload };
    case CardsActionTypes.SET_CARD_CVC:
      return { ...state, cardCvc: action.payload };
    case CardsActionTypes.CLEAR_CARDS:
      return { cards: [], cardNumber: '', cardExpiryDate: '', cardCvc: '' };
    default:
      return state;
  }
};
